var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row document-information-content",staticStyle:{"justify-content":"center"}},[_c('div',{staticClass:"form-group editor-wrapper"},[_c('vue-editor',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }